import { EvaluatedFactor, Factor } from './factor';

export interface IResource {
  resource: string;
  standardUnitOfMeasure: string;
  version: string;
  type?: ResourceType;
  conversions?: (Factor | EvaluatedFactor)[];
}

export enum ResourceType {
  GridSuppliedEnergy = 'GRID_SUPPLIED_ENERGY',
  CombinedResources = 'COMBINED_RESOURCES',
  Origin = 'ORIGIN',
}
